import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useEffect, useState } from "react";
import AppButton from "../../common/theme/Button";
import type { BundleRowChoice } from "../../common/utils/cartLineHelpers";
import commonStyles from "../../scss/common/common.module.scss";

const boxStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(480px, calc(100vw - 32px))",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "8px",
  border: "1px solid #E6E8ED",
};

interface IProps {
  open: boolean;
  choices: BundleRowChoice[];
  onChoose: (cartLineId: number) => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

const BundleSelectForItemModal = ({
  open,
  choices,
  onChoose,
  title = "Select a bundle",
  message = "Your cart includes a bundle. Choose which bundle this item belongs to.",
  confirmLabel = "Add to cart",
}: IProps) => {
  const [selected, setSelected] = useState<string>("");

  useEffect(() => {
    if (open) {
      setSelected("");
    }
  }, [open]);

  const handleConfirm = () => {
    if (!selected) return;
    onChoose(Number(selected));
  };

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
      }}
      disableEscapeKeyDown
      aria-labelledby="select-bundle-title"
    >
      <Box sx={boxStyle}>
        <h2
          id="select-bundle-title"
          style={{
            margin: "0 0 8px",
            fontSize: "20px",
            fontWeight: 700,
            color: "#1a2b4a",
          }}
        >
          {title}
        </h2>
        <p style={{ margin: "0 0 16px", color: "#555", fontSize: "14px" }}>
          {message}
        </p>
        <RadioGroup
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
        >
          {choices.map((c) => (
            <FormControlLabel
              key={c.cartLineId}
              value={String(c.cartLineId)}
              control={<Radio color="primary" />}
              label={c.label}
            />
          ))}
        </RadioGroup>
        <div className={commonStyles.shoppingChat_checkoutBtn} style={{ marginTop: 20 }}>
          <AppButton
            type="button"
            className={commonStyles.continue}
            disabled={!selected}
            onClick={handleConfirm}
          >
            {confirmLabel}
          </AppButton>
        </div>
      </Box>
    </Modal>
  );
};

export default BundleSelectForItemModal;
